<template>
    <request-egr
        :is-individual="isIndividual"
        :on-create="createRequest"
        :fields="fields"
        :total="total"
        :is-searching="isSearching"
        @search="handleSearch"
    />
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import RequestEgr from './RequestEgr.vue';

    export default {
        name: 'request-egr-container',
        components: {
            RequestEgr,
        },
        methods: {
            ...mapActions('request', ['createRequest', 'resetState']),
            ...mapActions('requestTableInns', ['searchIndividualsByName', 'searchCompaniesByName']),
            ...mapActions(['error']),

            handleSearch(values) {
                if (this.isIndividual) {
                    this.searchIndividualsByName({
                        fname: values.firstName,
                        lname: values.lastName,
                        mname: values.middleName,
                    });
                } else {
                    this.searchCompaniesByName(values.orgName);
                }
            }
        },
        created() {
            if (!this.selectedProducts.length) {
                this.$router.push({ name: 'requestProducts' });
            }
        },
        destroyed() {
            this.resetState();
        },
        computed: {
            ...mapGetters('request', [
                'selectedProducts',
                'productsObj',
                'total',
            ]),

            ...mapGetters('requestTableInns', {
                isSearching: 'isFetching'
            }),

            isIndividual() {
                return this.$route.path === '/requestEgrip';
            },

            fields() {
                return this.isIndividual
                    ? {
                        ipInn: { name: 'ipInn', required: true },
                        firstName: { name: 'firstName', required: true },
                        lastName: { name: 'lastName', required: true },
                        middleName: { name: 'middleName', required: true },
                    }
                    : {
                        ipInn: { name: 'ipInn', required: true },
                        firstName: { name: 'firstName', required: true },
                        lastName: { name: 'lastName', required: true },
                        middleName: { name: 'middleName', required: true },
                    }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// RequestEgrContainer.vue?5824cf6c